import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import { useBCRouting } from "../../providers/BCRoutingContextProvider";
import { SxProps, Theme, useTheme } from "@mui/material";
import { useDomainConfig } from "@/api/cache/appConfigQueryOptions";
import { ButtonName, InlineSvgIcon, parseThemeUrl } from "@brandclub/common-ui";
import { useUserProfile } from "@/hooks/useUserProfile";
import { ShopAppButton } from "../../components/button/ShopAppButton";

const MembershipButton = ({ mobile }: { mobile?: boolean }) => {
  const { data: domainConfig } = useDomainConfig();
  const theme = useTheme();
  const bcRouting = useBCRouting();
  // isFetched stays true when the profile is asked again. isLoading goes true again
  // for a signed-out shopper, and the button blinks.
  const { data: userProfile, isFetched: profileAnswered } = useUserProfile();

  const handleMembershipClick = () => {
    bcRouting.navigate(
      "https://" + domainConfig?.domainName + "/membership",
      "_blank"
    );
  };
  const content = mobile
    ? theme.content?.membershipButton?.signedOutMobile
    : theme.content?.membershipButton?.signedOutDesktop;
  const customImage = parseThemeUrl(
    content?.customIconStartSrc ?? content?.customIconEndSrc
  );
  const iconLabel = content?.iconLabel;

  const membershipButtonStyleOverride =
    theme.componentCSSOverrides?.[ButtonName.MembershipButton]?.[
      mobile ? "xs" : "md"
    ];
  const iconSize: number | string =
    (membershipButtonStyleOverride?.width ?? membershipButtonStyleOverride?.height ?? 24) as number | string;

  const textButton = !customImage;

  // Show nothing until the first profile answer, so the button does not appear and then go.
  if (!profileAnswered || userProfile) {
    return null;
  }

  if (textButton) {
    const text = content?.text;
    return (
      <ShopAppButton
        onClick={handleMembershipClick}
        buttonName={ButtonName.MembershipButton}
        variant="text"
        color="default"
        sx={membershipButtonStyleOverride as SxProps<Theme>}
      >
        <span>{text}</span>
      </ShopAppButton>
    );
  }

  return (
    <ShopAppButton
      onClick={handleMembershipClick}
      buttonName={ButtonName.MembershipButton}
      variant="icon"
      color="default"
      sx={membershipButtonStyleOverride as SxProps<Theme>}
      style={{
        display: "flex",
        flexDirection: iconLabel ? "column" : "row",
        alignItems: "center",
        justifyContent: "center",
        overflow: "visible",
      }}
    >
      {customImage ? (
        <div style={{ flexShrink: 0, width: iconSize, height: iconSize }}>
          <InlineSvgIcon
            src={customImage}
            alt="membershipButton Icon"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </div>
      ) : (
        <BookmarkBorderIcon />
      )}
      {iconLabel && (
        <span
          className="bc-icon-label"
          style={{
            fontSize: 11,
            lineHeight: 1,
            fontWeight: 400,
            color: "currentColor",
            whiteSpace: "nowrap",
            marginTop: 7,
            pointerEvents: "none",
          }}
        >
          {iconLabel}
        </span>
      )}
    </ShopAppButton>
  );
};

export default MembershipButton;
